module.exports = __webpack_public_path__ + "img/web-traffic.b2676ae.webp";